import type { I18n } from "@lingui/core";
import { plural, t } from "@lingui/core/macro";
import { secondsToDurationParts } from "@offstreetparking/design-system/formatters";

const durationUnits = ["years", "months", "days", "hours", "minutes", "seconds"] as const;

type DurationUnit = (typeof durationUnits)[number];

export const getLocalizedLargestDurationString = (seconds: number, i18n: I18n): string => {
	const durationObject = secondsToDurationParts({
		seconds,
	});
	let largestUnit: {
		value: number;
		unit: DurationUnit;
	} | null = null;
	for (const unit of durationUnits) {
		const value = durationObject[unit];
		if (value !== undefined && value > 0) {
			largestUnit = {
				value,
				unit,
			};
			break;
		}
	}
	if (!largestUnit || seconds < 60) {
		return t(i18n)`${plural(1, { one: "# min", other: "# min" })}`;
	}
	const { unit, value } = largestUnit;
	switch (unit) {
		case "years":
			return t(i18n)`${plural(value, { one: "# yr", other: "# yr" })}`;
		case "months":
			return t(i18n)`${plural(value, { one: "# mo", other: "# mo" })}`;
		case "days":
			return t(i18n)`${plural(value, { one: "# d", other: "# d" })}`;
		case "hours":
			return t(i18n)`${plural(value, { one: "# hr", other: "# hr" })}`;
		case "minutes":
		case "seconds":
			return t(i18n)`${plural(value, { one: "# min", other: "# min" })}`;
	}
};
